import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneCardCSSStyle } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ArtistToneCardComponent } from '../../featuredcategory/viewmodel/artist/artisttonecardcomponent';
import { ArtistToneEvenCardCSSStyleImpl } from '../../featuredcategory/viewmodel/artist/artisttoneevencardcssstyle';
import { ArtistToneCardCSSStyleImpl } from '../../featuredcategory/viewmodel/artist/artisttonecardcssstyle';
import { GridPaginationListViewModelImpl } from '../../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';

export class SearchToneArtistRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setLike(true);
        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setDelete(false);
        this.setTellAFriend(true);
        this.setAddWishList(true);
        this.setPlay(false);
        this.setIsToneSelect(true);
        this.setSettings(false);
        this.setAction(true);
    }
}


export class SearchListAtistToneViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
  
    constructor(offset: string, context: BaseContext, private marginTop: string)
    {
        super(offset, context);
        
        this.toneOddCardCSSStyle = new ArtistToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ArtistToneEvenCardCSSStyleImpl(context);
        this.toneRowOptionsPrivilage = new SearchToneArtistRowOptionsImpl();
    }

    // setTitle(title: string)
    // {
    //     this.title = title;
    // }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ArtistToneCardComponent toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} cardStyle={this.toneOddCardCSSStyle} key={position}  context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ArtistToneCardComponent toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} cardStyle={this.toneEvenCardCSSStyle} key={position} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/artist/searchlistartistviewmodel.tsx